import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingServicePages } from "@/data/roofingServiceContent";

const c = roofingServicePages["roof-replacement"];

export const Route = createFileRoute("/services/roof-replacement")({
  head: () => ({
    meta: [
      { title: "Roof Replacement Southern California | McKay Roofing & Solar" },
      { name: "description", content: "Full roof replacement across Southern California – shingle, tile and flat roof systems built for local sun, heat and coastal weather." },
      { property: "og:title", content: "Roof Replacement Southern California – McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/roof-replacement" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});